import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SearchSuggestion, SearchSuggestionGroup } from '../search-suggestions.model';

/**
 * Grouped type-ahead list inside the top menu search panel. View only: the search input stays in
 * IcTopMenuComponent, which forwards arrow keys and Enter here.
 */
@Component({
  selector: 'app-ic-search-suggestions',
  templateUrl: './ic-search-suggestions.component.html',
  styleUrls: ['./ic-search-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IcSearchSuggestionsComponent implements OnChanges {
  @Input() groups: SearchSuggestionGroup[] = [];
  @Input() loading = false;
  @Input() failed = false;
  @Output() pick = new EventEmitter<SearchSuggestion>();

  items: SearchSuggestion[] = [];
  active = -1;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.items = (this.groups || []).reduce((all, group) => all.concat(group.items), [] as SearchSuggestion[]);
    this.active = -1;
  }

  /** Arrow Down/Up: the first press lands on the first (or last) item, then wraps. */
  move(step: number, event?: Event): void {
    const count = this.items.length;
    if (!count) {
      return;
    }
    event?.preventDefault();
    this.active = this.active < 0 ? (step > 0 ? 0 : count - 1) : (this.active + step + count) % count;
    this.cdRef.markForCheck();
  }

  /** Enter: opens the highlighted item; false when nothing is highlighted so the full search runs. */
  pickActive(): boolean {
    const item = this.items[this.active];
    if (item) {
      this.pick.emit(item);
    }
    return !!item;
  }

  trackByLabel(_: number, group: SearchSuggestionGroup): string {
    return group.label;
  }

  trackByPath(_: number, item: SearchSuggestion): string {
    return item.path;
  }
}
